export const setIssuerPaged = (issuerPaged) => {
    return {
        type: 'SET_ISSUER_PAGED',
        issuerPaged,
    };
};

export const setIssuerFilters = (issuerFilters) => {
    return {
        type: 'SET_ISSUER_FILTERS',
        issuerFilters
    };
}

export const setIssuer = (issuer) => {
    return {
        type: 'SET_ISSUER',
        issuer
    };
};
